<template>
  <transition name="sticky-cta-slide">
    <div class="sticky-cta" v-show="active">
      <div class="sticky-cta__inner">
        <div class="sticky-cta__container">
          <button-vue
            :class="{
              'js-open-signup-popup': cta.openSignup,
              'js-open-login-popup': cta.openLogin
            }"
            :copy="cta.copy"
            :href="cta.href"
            :data="cta.data"
            :modifiers="['full']"
            event-category="footer-20200104-sticky_cta"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import getLocale from "@/utils/locale"
import Button from "@/shared/button"

export default {
  name: "StickyHeader",
  components: {
    ButtonVue: Button
  },
  props: {
    active: { type: Boolean, default: false },
    cta: {
      type: Object,
      default: () => {},
      validator: function (value) {
        return typeof value.copy === "string" && typeof value.href === "string"
      }
    }
  },
  computed: {
    logoLink() {
      if (this.hasLogoLink) {
        return `/${getLocale()}/`
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss">
.sticky-cta-slide-enter-active,
.sticky-cta-slide-leave-active {
  transition: 0.25s ease;
}

.sticky-cta-slide-enter,
.sticky-cta-slide-leave-to {
  transform: translateY(100%);

  opacity: 0;
}

.sticky-cta {
  position: fixed;
  bottom: 0;
  z-index: 5;

  width: 100%;

  background-color: $white;

  box-shadow: 0 -1px 2px 0 rgba(38, 34, 32, 0.1);

  &__inner {
    padding: $spacing-16;
  }
}
</style>
